// Footer.jsx
import React from "react";
import siteLogo from "../Assets/Townbell-new-svg-logo.svg";
import {
  FaArrowUp,
  FaTwitter,
  FaYoutube,
  FaInstagram,
  FaFacebook,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { FaXTwitter } from "react-icons/fa6";

const Footer = () => {
  const navigate = useNavigate();
  return (
    <div
      className="footer w-full mt-0 px-[10px] py-[30px] md:px-0 flex flex-col items-center relative"
      data-theme="dark"
      style={{ background:"#521a27"
 }}
    >
      <div className="footer-inner relative overflow-hidden w-[var(--box-width)] lg:px-[40px] p-[10px] py-[15px] md:p-[20px] flex flex-col items-center gap-[10px] rounded-[40px]">
        <div className="footer-top w-[95%] lg:w-full flex flex-col items-center gap-[20px]">
          <img
            onClick={() => navigate("/")}
            className="lg:w-[100px] w-[100px] "
            src={siteLogo}
            alt="townbell"
            style={{ filter:"brightness(0) invert(1)"}}
          />
          <div className="w-full flex flex-col items-center p-[18px] md:px-[58px] md:py-[47px] border-[1px] border-solid border-[#ffffff4d] rounded-[40px] bg-[#0000000a]">
            <h2 className="archivo mb-6 lg:text-[45px] md:text-[33px] text-[25px] text-white font-bold leading-[110%] text-center lg:w-[90%] w-[100%] ">
              Where Dreams Rise—Your Trusted Builder in Tricity. Let’s Connect!
            </h2>

            <div className="footer-bottom lg:w-full flex flex-wrap gap-[10px]">
              <a
                className="w-full md:w-[49%] lg:w-[49.5%] bg-transparent flex items-center justify-between border-[1px] border-solid border-transparent text-[12px] font-normal text-white rounded-[50px] uppercase leading-[1em]"
                href="https://www.facebook.com/profile.php?id=61579054784028"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="flex items-center gap-[10px] pl-[20px] bg-[#00000012]">
                  <FaFacebook />
                  Facebook
                </span>
                <span className="flex items-center justify-center bg-[#00000012]">
                  <FaArrowUp />
                </span>
              </a>
              <a
                className="w-full md:w-[49%] lg:w-[49.5%] bg-transparent flex items-center justify-between border-[1px] border-solid border-transparent text-[12px] font-normal text-white rounded-[50px] uppercase leading-[1em]"
                href="https://www.instagram.com/town_bell/?hl=en"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="flex items-center gap-[10px] pl-[20px] bg-[#00000012]">
                  <FaInstagram />
                  Instagram
                </span>
                <span className="flex items-center justify-center bg-[#00000012]">
                  <FaArrowUp />
                </span>
              </a>

              <a
                className="w-full md:w-[49%] lg:w-[49.5%] bg-transparent flex items-center justify-between border-[1px] border-solid border-transparent text-[12px] font-normal text-white rounded-[50px] uppercase leading-[1em]"
                href="https://www.youtube.com/@Town-Bell"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="flex items-center gap-[10px] pl-[20px] bg-[#00000012]">
                  <FaYoutube />
                  Youtube
                </span>
                <span className="flex items-center justify-center bg-[#00000012]">
                  <FaArrowUp />
                </span>
              </a>

              <a
                className="lg:w-[49.5%] md:w-[49%] w-full bg-transparent flex items-center justify-between border-[1px] border-solid border-transparent text-[12px] font-normal text-white rounded-[50px] uppercase leading-[1em]"
                href="https://x.com/Townbell1"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="flex items-center gap-[10px] pl-[20px] bg-[#00000012]">
                  <FaXTwitter />
                  Twitter
                </span>
                <span className="flex items-center justify-center bg-[#00000012]">
                  <FaArrowUp />
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright Section */}
      <div className="copyright w-[90%] mt-[20px] flex flex-col md:flex-row items-center justify-between gap-[10px]">
        <p className="inter text-[12px] text-[#ffffff] font-light leading-[1em]">
          © {new Date().getFullYear()} Townbell. All rights reserved.
        </p>
        <div className="flex items-center gap-[20px]">
          <a
            className="inter text-[12px] text-[#ffffff] hover:text-[#ffffff99] font-light leading-[1em]"
            href="/privacy-policy"
          >
            Privacy Policy
          </a>
          <a
            className="inter text-[12px] text-[#ffffff] hover:text-[#ffffff99] font-light leading-[1em]"
            href="/terms-of-service"
          >
            Terms of Service
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
